<template>
  <div class="enrollment-guid">
    <div v-if="selectedProvider.selfEnrollmentEnabled != undefined">
      <ErrorBox
        v-if="timeoutFlag"
        title="Error"
        errors="Your session has timed out due to inactivity. Your enrollment was not submitted."
        class="guid-error-box"
      />

      <!-- Provider has Balance File Enrollment Enabled and Self Enrollment is True -->
      <div
        v-if="
          (selectedProvider.balanceFileEnrollmentEnabled ||
            selectedProvider.epicEnrollmentEnabled) &&
          selectedProvider.selfEnrollmentEnabled
        "
        class="enrollment-guid_provider-wrapper-balancefile vcore_row vcore_no-gutters"
      >
        <i
          class="vcore_icon icon-check vcore_hidden--lg--up mobile_checkmark_icon"
        />
        <div class="vcore_col--xs--12 vcore_col--lg--9">
          <div class="vcore_row vcore_no-gutters">
            <div
              class="enrollment-guid_provider_logo_wrapper-balancefile vcore_col--xs--12 vcore_col--lg--3"
            >
              <div class="enrollment-guid_provider_logo-balancefile">
                <LogoDisplay :logo-src="logo"></LogoDisplay>
              </div>
            </div>
            <div
              class="enrollment-guid_provider_info_wrapper vcore_col--xs--12 vcore_col--lg--9"
            >
              <div class="enrollment-guid_provider_info">
                <div
                  class="enrollment-guid_provider_info_label vcore_hidden--md--down"
                >
                  Enroll with your provider
                </div>
                <div
                  class="enrollment-guid_provider_info_name vcore_hidden--md--down"
                >
                  {{ selectedProvider.providerName }}
                </div>
                <div
                  class="enrollment-guid_provider_info_name-balancefile vcore_hidden--lg--up"
                >
                  {{ selectedProvider.providerName }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- If Balance File Enrollment is not Enabled -->
        <div
          v-if="!selectedProvider.balanceFileEnrollmentEnabled"
          class="enrollment-guid_provider_action vcore_col--xs--12 vcore_col--md--4 vcore_col--lg--3"
        >
          <!-- If Self Enrollment is Enabled -->
          <Button
            v-if="selectedProvider.selfEnrollmentEnabled"
            size="large"
            color="blue"
            variant="secondary"
            classes="hover_blue"
            block
            @click.native="handleEnrollClick"
          >
            Enroll
          </Button>
          <!-- If Self Enrollment is not Enabled -->
          <div v-else class="provider-selection-item_action_unavailable">
            <span>
              Please contact {{ selectedProvider.providerName }} directly to enroll for HSF<sup class="sup">&reg;</sup>.
            </span>
          </div>
        </div>

        <div
          v-if="
            selectedProvider.selfEnrollmentEnabled
          "
          class="vcore_col--xs--12 vcore_col--lg--12"
        >
          <p
            v-if="selectedProvider.selfEnrollmentUrl"
            class="enrollment-guid_provider_info_wrapper_myChart"
            @click="goToSite"
            style="margin-top: 5px"
          >
            {{ selectedProvider.selfEnrollmentUrl }}
          </p>
          <!-- Self enrollment URL actually means the text from -->
        </div>
        <!-- the Enrollment section in the New Admin site -->
      </div>

      <!-- For all other providers who do not have Balance File or Epic Enrollment -->
      <div
        v-else
        class="enrollment-guid_provider-wrapper vcore_row vcore_no-gutters"
      >
        <div class="vcore_col--xs--12 vcore_col--md--8 vcore_col--lg--9">
          <div class="vcore_row vcore_no-gutters">
            <div
              class="enrollment-guid_provider_logo_wrapper vcore_col--xs--12 vcore_col--sm--3"
            >
              <div class="enrollment-guid_provider_logo">
                <LogoDisplay :logo-src="logo"></LogoDisplay>
              </div>
            </div>
            <div
              v-if="selectedProvider.selfEnrollmentEnabled"
              class="enrollment-guid_provider_info_wrapper vcore_col--xs--12 vcore_col--sm--9"
            >
              <div class="enrollment-guid_provider_info">
                <div class="enrollment-guid_provider_info_label">
                  Enroll with your provider
                </div>
                <div class="enrollment-guid_provider_info_name">
                  {{ selectedProvider.providerName }}
                </div>
              </div>
            </div>
            <div v-if="!selectedProvider.selfEnrollmentEnabled" style="padding: 3% 20px;" class="provider-selection-item_action_unavailable contact-text vcore_col--xs--9 vcore_col--sm--9">
              <span>
                Please contact {{ selectedProvider.providerName }} directly to enroll for HSF<sup class="sup">&reg;</sup>.
              </span>
            </div>
          </div>
          
        </div>
        <div
          v-if="!selectedProvider.balanceFileEnrollmentEnabled"
          class="enrollment-guid_provider_action vcore_col--xs--12 vcore_col--md--4 vcore_col--lg--3"
        >
          <Button
            v-if="selectedProvider.selfEnrollmentEnabled"
            size="large"
            color="blue"
            variant="secondary"
            classes="hover_blue"
            block
            @click.native="handleEnrollClick"
          >
            Enroll
          </Button>
        </div>
        <div
          v-if="
            selectedProvider.selfEnrollmentEnabled
          "
          class="vcore_col--xs--12 vcore_col--lg--12"
        >
          <p
            v-if="selectedProvider.selfEnrollmentUrl"
            class="enrollment-guid_provider_info_wrapper_myChart"
            @click="goToSite"
            style="margin-top: 5px"
          >
            {{ selectedProvider.selfEnrollmentUrl }}
          </p>
          <!-- Self enrollment URL actually means the text from -->
        </div>
        <!-- the Enrollment section in the New Admin site -->
      </div>
      <ProviderStatementAuthenticate
        v-if="selectedProvider.balanceFileEnrollmentEnabled"
        :fromguid="true"
      >
      </ProviderStatementAuthenticate>
    </div>
  </div>
</template>

<script>
import Button from "@Shared/components/Button";
import LogoDisplay from "../LogoDisplay";
import { mapGetters, mapActions } from "vuex";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";
import ErrorBox from "@Shared/components/ErrorBox";
import ProviderStatementAuthenticate from "../../components/Enrollment/ProviderStatementAuthenticate";

export default {
  name: "EnrollmentGUID",
  components: {
    Button,
    LogoDisplay,
    ErrorBox,
    ProviderStatementAuthenticate,
  },
  computed: {
    ...mapGetters([
      "selectedProvider",
      "enrollmentCurrentStepIndex",
      "timeoutFlag",
    ]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.LOGO,
        this.selectedProvider.customBrandingList
      );
    },
    console: () => console,
  },
  methods: {
    ...mapActions(["incrementEnrollmentCurrentStepIndex"]),

    handleEnrollClick() {
      if (this.enrollmentCurrentStepIndex == -1) {
        this.incrementEnrollmentCurrentStepIndex();
      }
      this.incrementEnrollmentCurrentStepIndex();

      this.$router.push({
        name: "enroll-forms",
        params: { step: "frp-information" },
      });
      this.$ga.event({
        eventCategory: "Provider Enrollment",
        eventAction: "Button Click",
        eventLabel: "Guid",
      });
    },
    goToSite() {
      if (
        this.selectedProvider.customGuidanceUrl
      ) {
        window.open(this.selectedProvider.customGuidanceUrl, "_blank");
      }
    },
  },
  beforeUpdate() {
      document.title = "HSF Enrollment | " + this.selectedProvider.institutionName;
  }
};
</script>

<style lang="scss" scoped>
.enrollment-guid {
  margin-top: 50px;

  .enrollment-guid_title {
    font-size: 24px;
    font-weight: 600;
  }

  .enrollment-guid_provider-wrapper {
    background-color: $color_dark-blue;
    border-radius: 10px;
    padding: 30px 38px;
    margin-top: 30px;
  }

  .enrollment-guid_provider-wrapper-balancefile {
    background-color: $color_dark-blue;
    border-radius: 10px;
    padding: 30px 38px;
    margin-top: 30px;

    @media (max-width: $grid-breakpoint-lg) {
      background-color: #f7f8fa;
      border-radius: 10px;
      padding: 30px 38px;
      position: relative;
    }
  }

  .enrollment-guid_provider_logo_wrapper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px !important;
    min-height: 80px;

    .enrollment-guid_provider_logo {
      overflow: hidden;

      & > img {
        width: 100%;
      }
    }

    .enrollment-guid_logo-default {
      height: 50px;
    }
  }

  .enrollment-guid_provider_logo_wrapper-balancefile {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px !important;
    min-height: 80px;

    @media (max-width: $grid-breakpoint-lg) {
      background-color: #f7f8fa;
      border-radius: 0px;
      padding: 30px 38px;
      position: relative;
    }

    .enrollment-guid_provider_logo {
      overflow: hidden;

      & > img {
        width: 100%;
      }
    }

    .enrollment-guid_logo-default {
      height: 50px;
    }
  }

  ::v-deep .logo-display img {
    display: block;
    margin: auto;
  }

  .mobile_checkmark_icon {
    position: absolute;
    top: -15px;
    left: -5px;
    background-color: $color_dark-green;
    color: $color_white;
    height: 30px;
    width: 30px;
    line-height: 30px;
    text-align: center;
    border-radius: 999px;

    @media (max-width: $grid-breakpoint-lg) {
      margin: 0 auto;
      left: 0;
      right: 0;
    }
  }

  .enrollment-guid_provider_info_wrapper {
    color: #ffffff;
    font-size: 20px;
    line-height: 27px;

    .enrollment-guid_provider_info {
      padding: 10px 20px;

      .enrollment-guid_provider_info_label {
        font-weight: 600;
        font-size: 21px;
        font-family: Poppins;
      }

      .enrollment-guid_provider_info_name {
        font-weight: bold;
        font-size: 20px;
        margin-top: 10px;
      }

      .enrollment-guid_provider_info_name-balancefile {
        font-weight: bold;
        font-size: 20px;
        margin-top: 10px;

        @media (max-width: $grid-breakpoint-lg) {
          text-align: center;
          color: #41434b;
          margin-top: 0px;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
}

.provider-selection-item_action_unavailable {
  font-weight: 600;
  font-size: 21px;
  font-family: Poppins;
  line-height: 27px;
  color: #ffffff;
  padding: 10px 0px;
}

.contact-text {
  font-size: 20px;
}

.sup {
  font-size: 70%;
  vertical-align: super;
}

.enrollment-guid_provider_info_wrapper_myChart {
  font-weight: bold;
  font-size: 14px;
  font-family: Poppins;
  color: #ffffff;
  text-align: right;
  overflow-wrap: break-word;
  padding-top: 5px;
  cursor: pointer;

  @media (max-width: $grid-breakpoint-lg) {
    text-align: center;
    color: #41434b;
    margin-top: 0px;
    font-size: 12px;
    line-height: 22px;
    overflow-wrap: break-word;
    padding-top: 5px;
    cursor: inherit;
  }
}
</style>
